module.exports = __webpack_public_path__ + "static/media/enfase-full.e293f653.jpg";